import { useState } from "react"
import { Input } from "reactstrap";


const useCourseSelection = ({ nameOfCourseA, nameOfCourseB, nameOfCourseC}) => {
  const [selectedCourse, setSelectedCourse] = useState('AB');
  const courseOptions = {
    'AB': 'A&B',
    'AC': 'A&C',
    'BC': 'B&C',
    'BA': 'B&A',
    'CA': 'C&A',
    'CB': 'C&B',
  }

  const couserLabel = (key) => {
    const value = courseOptions[key];
    const splittedValues = value.split('&');
    console.log("nameOfCourseA".includes, nameOfCourseA)
    return splittedValues.map((portion) => {
      if(portion === 'A')
        return nameOfCourseA;
      if(portion === 'B')
        return nameOfCourseB;
      if(portion === 'C')
        return nameOfCourseC;
    }).join(' & ');
  }
  const SelectCourse = ({style}) => (
    <Input
      type="select"
      value={selectedCourse || ""}
      style={{width: 300, ...style}}
      onChange={(e) => setSelectedCourse(e.target.value)}
    >
      {Object.keys(courseOptions).map((key) => (
        <option key={key} value={key}>{couserLabel(key)}</option>
      ))}
    </Input>
  )

  return {selectedCourse, SelectCourse}
}

export default useCourseSelection;